module.exports = __webpack_public_path__ + "static/media/43_tn.bfc553fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/thumbnails/43_tn.jpg
// module id = 679
// module chunks = 0